export const Logo = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      color="black"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Alpaca"
      className="block"
    >
      <title>Alpaca</title>
      <circle cx="16" cy="16" r="16" fill="white" />
      <g transform="translate(4 4) scale(0.75)">
        <path
          d="M16.0107 7.45738e-06C24.845 7.45738e-06 32.0095 7.33697 32.001 16.3789C32.001 22.7561 28.44 28.2962 23.2393 30.9961C23.0627 31.0706 22.7484 31.1673 22.3525 31.1016C22.176 31.0709 21.8231 31.0133 21.5605 30.7285C21.5087 30.6627 21.371 30.514 21.3193 30.2822C21.3064 30.2209 21.2979 30.1458 21.2979 30.0801V13.6006C21.2979 12.816 21.1081 12.0402 20.7422 11.3477C20.3763 10.6553 19.8431 10.0589 19.2061 9.6338C19.404 9.30513 19.5109 8.91932 19.5195 8.53809C19.5281 8.15686 19.4384 7.77542 19.249 7.4336C19.0596 7.09173 18.7877 6.80712 18.4648 6.61427C18.142 6.42143 17.7632 6.31544 17.3887 6.31544V8.15626H17.3584C17.2636 7.64806 17.0142 7.17921 16.627 6.85059C16.2395 6.50872 15.7484 6.32911 15.249 6.32911V8.87989H14.5391C13.4843 8.92372 12.4893 9.39317 11.7617 10.169C11.0343 10.9447 10.625 11.9879 10.625 13.0615V13.083L8.23633 14.665C8.3956 15.6993 8.90299 16.6331 9.67773 17.3037C10.4526 17.9743 11.2882 18.3466 12.2998 18.3467H12.416L11.1416 32C4.6883 29.8961 0.000118452 23.6987 0 16.3838C0 7.32436 7.16368 -0.00853575 16.0107 7.45738e-06ZM14.7979 13.3418C14.7979 13.6092 14.6951 13.8638 14.5186 14.0566C14.3291 14.2495 14.0917 14.3545 13.8291 14.3545H12.8477L12.8906 13.8457L12.8867 13.8418C12.8867 13.7147 12.9385 13.5876 13.0332 13.4912C13.1279 13.3949 13.2522 13.3419 13.377 13.3418H14.7979Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
